import { createContext } from 'react';

export const themeContext = createContext({
    themeCode: ''
})
